<template>
   <div class="row">
      <div id="search-nav" class="col-12 d-block btn-group dropup">
         <button type="button" class="btn btn-primary dropdown-toggle d-block d-lg-none" :class="pesquisa.resultado.length > 0 ? '' : 'empty'" data-toggle="dropdown" aria-expanded="false">
            <i class="far fa-search font-17"></i>
         </button>
         <div class="card mb-2 dropdown-menu dropdown-menu-left">
            <div class="card-body pb-0">
               <div class="row m-0">
                  <div class="col-12 col-sm-6 col-md-2 mb-3 px-1">
                     <label><i class="far fa-filter font-13 color-theme mr-1"></i> Tipo de pesquisa</label>
                     <v-select class="rounded" title="Desktop" :options="['Nome', 'CNPJ']" v-model="pesquisa.tipo" />
                     <select title="Mobile" class="form-control rounded" v-model="pesquisa.tipo">
                        <option v-for="(option, index) in ['Nome', 'CNPJ']" :key="index" :value="option">{{ option }}</option>
                     </select>
                  </div>
                  <div class="col-12 col-sm-6 col-md-7 mb-3 px-1" >
                     <label v-if="pesquisa.tipo == 'Nome'"><i class="far fa-building font-13 color-theme mr-1"></i> Nome</label>
                     <label v-else-if="pesquisa.tipo == 'CNPJ'"><i class="far fa-id-card font-13 color-theme mr-1"></i> CNPJ</label>
                     <input type="text" class="form-control rounded" v-model="pesquisa.valor" maxlength="200" @keyup.enter="buscarEntidades(0)" placeholder="Busque por nome ou CNPJ" />
                  </div>
                  <div class="col-5 col-sm-6 col-md-1 mb-3 px-1 align-self-end">
                     <button type="button" class="btn btn-primary w-100 rounded" @click="buscarEntidades(0)">
                        <i class="fa fa-search font-13"></i>
                     </button>
                  </div>
                  <div class="col-7 col-sm-6 col-md-2 mb-3 px-1 align-self-end">
                     <button type="button" class="btn btn-primary w-100 rounded" @click="abrirAddEntidade">
                        <i class="fa fa-plus font-13 mr-1"></i> Adicionar
                     </button>
                  </div>
               </div>
            </div>
         </div>
      </div>

      <div class="col-12" v-if="pesquisa.resultado.length > 0">
			<div class="card mb-0">
				<div class="card-body">
					<div class="row px-1">
						<div class="col mb-2 align-self-center">
							<div class="limitador-1 mb-1"><i class="fas fa-angle-right color-theme me-1"></i> {{ pesquisa.resultado.length == 100 ? 'Limitado a ': '' }} {{ pesquisa.resultado.length }} resultado(s)</div>
						</div>
					</div>
               <div class="cards-3">
                  <entidade v-for="(entidade, index) in pesquisa.resultado" :key="index" :entidade="entidade" :index="index" @editar="abrirEditarEntidade($event)" @visualizar="verEntidade($event)" @imprimir="imprimirRelatorio($event)" />
               </div>
				</div>
			</div>
      </div>
      <div class="col-12 my-5 text-center" v-else>Nenhum resultado encontrado</div>

      <div class="col-12">
         <div class="d-flex justify-content-center my-4" v-if="totalPagina == 50">
            <button class="btn btn-primary rounded" title="Carregar mais" @click="buscarEntidades(null)">
               <span><i class="fal fa-sync-alt mr-2"></i>Carregar mais</span>
            </button>
         </div>
      </div>

      <div class="modal fade" id="modalVerEntidade" tabindex="-1" aria-labelledby="modalVerEntidadeLabel" aria-hidden="true">
         <div class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
            <div class="modal-content h-100">
               <div class="modal-header">
                  <h5 class="modal-title h4" id="modalVerEntidadeLabel">Info</h5>
                  <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span></button>
               </div>
               <div class="modal-body" v-if="modalInfo.id != null">
                  <div class="card mb-2">
                     <div class="card-body py-3">
                        <ul class="nav nav-tabs3 overflow">
                           <li class="nav-item"><a class="nav-link active text-uppercase fw-bold" data-toggle="tab" href="#sentenciados"><i class="far fa-id-card mr-1"></i>Sentenciados</a></li>
                           <li class="nav-item"><a class="nav-link text-uppercase fw-bold" data-toggle="tab" href="#servicos"><i class="far fa-file-alt mr-1"></i>Serviços</a></li>
                        </ul>
                     </div>
                  </div>
                  <div class="tab-content padding-0 mt-0">
                     <div class="tab-pane active" id="sentenciados">
                        <div class="card">
                           <div class="card-body">
                              
                              <div class="row m-0 mb-4 p-2 bg-light rounded align-items-center">
                                 <div class="col-12 col-md-3 mb-2 px-1">
                                    <label class="font-12 mb-1"><i class="far fa-search font-11 color-theme mr-1"></i> Pesquisar por Nome</label>
                                    <input type="text" class="form-control form-control-sm rounded" v-model="filtrosModal.nome" placeholder="Digite o nome..." />
                                 </div>
                                 <div class="col-12 col-md-3 mb-2 px-1">
                                    <label class="font-12 mb-1"><i class="far fa-gavel font-11 color-theme mr-1"></i> Vara</label>
                                    <v-select class="rounded v-select-sm" :options="['Todos', 'Criminal', 'JECRIM']" v-model="filtrosModal.vara" />
                                 </div>
                                 <div class="col-12 col-md-3 mb-2 px-1">
                                    <label class="font-12 mb-1"><i class="far fa-venus-mars font-11 color-theme mr-1"></i> Sexo</label>
                                    <v-select class="rounded v-select-sm" :options="['Todos', 'Masculino', 'Feminino']" v-model="filtrosModal.sexo" />
                                 </div>
                                 <div class="col-12 col-md-3 mb-2 px-1">
                                    <label class="font-12 mb-1"><i class="far fa-info-circle font-11 color-theme mr-1"></i> Status</label>
                                    <v-select class="rounded v-select-sm" :options="['Todos', 'Em cumprimento', 'Descumprimento', 'Arquivado']" v-model="filtrosModal.status" />
                                 </div>
                              </div>

                              <div class="row px-1">
                                 <div class="col mb-2 align-self-center">
                                    <div class="limitador-1 mb-1"><i class="fas fa-angle-right color-theme me-1"></i> {{ sentenciadosFiltrados.length }} resultado(s) encontrado(s)</div>
                                 </div>
                              </div>
                              <div class="cards-3">
                                 <sentenciado v-for="(sentenciado, index) in sentenciadosFiltrados" :key="index" :sentenciado="sentenciado" :index="index"/>
                              </div>
                              <div class="w-100 text-center py-4 text-muted" v-if="sentenciadosFiltrados.length === 0">Nenhum sentenciado corresponde aos filtros aplicados.</div>
                           </div>
                        </div>
                     </div>

                     <div class="tab-pane" id="servicos">
                        <div class="card">
                           <div class="card-body">
                              <div class="row px-1">
                                 <div class="col mb-2 align-self-center">
                                    <div class="limitador-1 mb-1"><i class="fas fa-angle-right color-theme me-1"></i> {{ modalInfo.servicos.length == 100 ? 'Limitado a ': '' }} {{ modalInfo.servicos.length }} resultado(s)</div>
                                 </div>
                              </div>
                              <div class="cards-2">
                                 <servico v-for="(servico, index) in modalInfo.servicos" :key="index" :servico="servico" :view="true" />
                              </div>
                              <div class="w-100 px-1 py-4 text-center" v-if="modalInfo.servicos == null || modalInfo.servicos.length == 0">Nenhum serviço encontrado</div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
               <div class="modal-body my-5 text-center font-16" v-else>Nenhuma informação encontrada</div>
               <div class="modal-footer">
                  <button type="button" class="btn btn-round btn-secondary" data-dismiss="modal">Fechar</button>
               </div>
            </div>
         </div>
      </div>

      <div class="modal fade" id="modalEntidade" tabindex="-1" aria-labelledby="modalEntidadeLabel" aria-hidden="true">
         <div class="modal-dialog modal-dialog-centered modal-lg modal-dialog-scrollable">
            <div class="modal-content">
               <div class="modal-header">
                  <h5 class="modal-title h4" id="modalEntidadeLabel" v-if="modal != null && modal.id != null">Editar entidade</h5>
                  <h5 class="modal-title h4" id="modalEntidadeLabel" v-else>Adicionar entidade</h5>
                  <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span></button>
               </div>
               <div class="modal-body" v-if="modal != null">
                  <div class="card mb-0">
                     <div class="card-body">
                        <div class="row m-0">
                           <div class="col-12 px-1 mb-3">
                              <label class="mb-1"><i class="far fa-building color-theme font-13 mr-1"></i> Nome *</label>
                              <input type="text" class="form-control rounded" maxlength="200" v-model="modal.nome" />
                           </div>
                           <div class="col-12 px-1 mb-3">
                              <label class="mb-1"><i class="far fa-address-card color-theme font-13 mr-1"></i> CNPJ *</label>
                              <input type="text" class="form-control rounded" v-mask="'##.###.###/####-##'" v-model="modal.cnpj" />
                           </div>
                           <div class="col-12 px-1 mb-3">
                              <label class="mb-1"><i class="far fa-envelope color-theme font-13 mr-1"></i> Email *</label>
                              <input type="email" class="form-control rounded" maxlength="200" v-model="modal.email" />
                           </div>
                           <div class="col-12 px-1 mb-3">
                              <label class="mb-1"><i class="far fa-phone-alt color-theme font-13 mr-1"></i> Telefone</label>
                              <input type="text" class="form-control rounded" maxlength="200" v-model="modal.telefone" v-mask="'+## ## #####-####'" />
                           </div>
                           <div class="col-12 px-1 mb-3">
                              <div class="row m-0">
                                 <div class="col-10 pl-0 pr-1">
                                    <label class="mb-1"><i class="far fa-map-marker color-theme font-13 mr-1"></i> CEP</label>
                                    <input type="text" class="form-control rounded" v-mask="'#####-###'" v-model="modal.cep" @keyup.enter="buscarCEP" />
                                 </div>
                                 <div class="col-2 pl-1 pr-0 align-self-end">
                                    <button class="btn btn-primary w-100 rounded" @click="buscarCEP">
                                       <i class="far fa-search mr-1"></i>
                                    </button>
                                 </div>
                              </div>
                           </div>
                           <div class="col-12 px-1 mb-3">
                              <label class="mb-1"><i class="far fa-map-marker color-theme font-13 mr-1"></i> Endereço</label>
                              <input type="text" class="form-control rounded" maxlength="200" v-model="modal.endereco" />
                           </div>
                           <div class="col-12 px-1 mb-3">
                              <label class="mb-1"><i class="far fa-building color-theme font-13 mr-1"></i> Nome do Responsável</label>
                              <input type="text" class="form-control rounded" maxlength="200" v-model="modal.nomeResponsavel" />
                           </div>
                           <div class="col-12 px-1 mb-0">
                              <label class="mb-1"><i class="far fa-phone-alt color-theme font-13 mr-1"></i> Telefone Responsável</label>
                              <input type="text" class="form-control rounded" maxlength="200" v-model="modal.telefoneResponsavel" v-mask="'+## ## #####-####'" />
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
               <div class="modal-body my-5 text-center font-16" v-else>Nenhuma informação encontrada</div>
               <div class="modal-footer">
                  <button type="button" class="btn btn-round btn-primary" @click="salvarEntidade">Salvar</button>
                  <button type="button" class="btn btn-round btn-secondary" data-dismiss="modal">Fechar</button>
               </div>
            </div>
         </div>
      </div>

      <div class="modal fade" id="modalRelatorioEntidade" tabindex="-1" aria-labelledby="modalRelatorioEntidadeLabel" aria-hidden="true">
         <div class="modal-dialog modal-dialog-centered modal-md">
            <div class="modal-content">
               <div class="modal-header">
                  <h5 class="modal-title h4" id="modalRelatorioEntidadeLabel">Filtros do Relatório</h5>
                  <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span></button>
               </div>
               <div class="modal-body">
                  <div class="card mb-0">
                     <div class="card-body">
                        <div class="row m-0">
                           <div class="col-12 px-1 mb-3">
                              <label class="mb-1"><i class="far fa-building color-theme font-13 mr-1"></i> Entidade</label>
                              <v-select class="rounded" :options="['Todas', modalRelatorio.entidadeNome]" v-model="modalRelatorio.entidadeOpcao" />
                           </div>
                           <div class="col-12 px-1 mb-3">
                              <label class="mb-1"><i class="far fa-gavel color-theme font-13 mr-1"></i> Vara de Origem</label>
                              <v-select class="rounded" :options="['Todos', 'Criminal', 'JECRIM']" v-model="modalRelatorio.varaOrigem" />
                           </div>
                           <div class="col-12 px-1 mb-3">
                              <label class="mb-1"><i class="far fa-venus-mars color-theme font-13 mr-1"></i> Sexo</label>
                              <v-select class="rounded" :options="['Todos', 'Masculino', 'Feminino']" v-model="modalRelatorio.sexo" />
                           </div>
                           <div class="col-12 px-1 mb-0">
                              <label class="mb-1"><i class="far fa-info-circle color-theme font-13 mr-1"></i> Status</label>
                              <v-select class="rounded" :options="['Todos', 'Em cumprimento', 'Descumprimento', 'Arquivado']" v-model="modalRelatorio.filtro" />
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
               <div class="modal-footer">
                  <button type="button" class="btn btn-round btn-primary" @click="gerarRelatorioEntidade">Gerar Relatório</button>
                  <button type="button" class="btn btn-round btn-secondary" data-dismiss="modal">Fechar</button>
               </div>
            </div>
         </div>
      </div>

      <div class="col-12 d-none">
         <section ref="html2Pdf">
            <div class="pdf-container" v-if="!isRelatorioMacro">
               <div class="pdf-header">
                  <div class="pdf-header-content">
                     <div class="pdf-header-info">
                        <h2 class="pdf-title">Relatório de Entidade</h2>
                        <div class="pdf-subtitle">Informações da Entidade</div>
                     </div>
                  </div>
               </div>

               <div class="pdf-entity-info">
                  <div class="pdf-info-row">
                     <div class="pdf-info-item">
                        <span class="pdf-label">Nome:</span>
                        <span class="pdf-value">{{ dadosPdf.nome || '-' }}</span>
                     </div>
                  </div>
                  <div class="pdf-info-row">
                     <div class="pdf-info-item">
                        <span class="pdf-label">CNPJ:</span>
                        <span class="pdf-value">{{ dadosPdf.cnpj || '-' }}</span>
                     </div>
                     <div class="pdf-info-item">
                        <span class="pdf-label">E-mail:</span>
                        <span class="pdf-value">{{ dadosPdf.email || '-' }}</span>
                     </div>
                  </div>
                  <div class="pdf-info-row">
                     <div class="pdf-info-item">
                        <span class="pdf-label">Endereço:</span>
                        <span class="pdf-value">{{ dadosPdf.endereco || '-' }}</span>
                     </div>
                  </div>
                  <div class="pdf-info-row">
                     <div class="pdf-info-item">
                        <span class="pdf-label">Telefone:</span>
                        <span class="pdf-value">{{ dadosPdf.telefone || '-' }}</span>
                     </div>
                     <div class="pdf-info-item">
                        <span class="pdf-label">Total de Sentenciados:</span>
                        <span class="pdf-value">{{ dadosPdf.sentenciado ? dadosPdf.sentenciado.length : 0 }}</span>
                     </div>
                  </div>
               </div>

               <div class="pdf-relatorio-stats mt-3 mb-2" v-if="dadosPdf.totalGeral !== undefined">
                  <span class="pdf-stat-badge">{{ dadosPdf.totalGeral }} {{ dadosPdf.totalGeral === 1 ? 'resultado' : 'resultados' }}</span>
                  <span class="pdf-stat-badge">{{ dadosPdf.totalEmCumprimento }} em cumprimento</span>
                  <span class="pdf-stat-badge">{{ dadosPdf.totalDescumprimento }} em descumprimento</span>
                  <span class="pdf-stat-badge">{{ dadosPdf.totalArquivado }} arquivados</span>
                  <span class="pdf-stat-badge">{{ dadosPdf.totalFinalizados }} finalizados</span>
               </div>

               <div class="pdf-sentenciados-section">
                  <h3 class="pdf-section-title">Sentenciados</h3>
                  <div class="pdf-sentenciados-list">
                     <div v-for="(sentenciado, index) in dadosPdf.sentenciado" :key="index" class="pdf-sentenciado-card">
                        <div class="pdf-card-header">
                           <span class="pdf-card-number">{{ index + 1 }}</span>
                           <span class="pdf-card-name">{{ sentenciado.nomeCompleto || '-' }}</span>
                        </div>
                        <div class="pdf-card-body">
                           <div class="pdf-card-row">
                              <div class="pdf-card-col">
                                 <span class="pdf-card-label">Data de Nascimento:</span>
                                 <span class="pdf-card-value">{{ formatarData(sentenciado.dataNascimento) }}</span>
                              </div>
                              <div class="pdf-card-col">
                                 <span class="pdf-card-label">Sexo:</span>
                                 <span class="pdf-card-value">{{ sentenciado.sexo || '-' }}</span>
                              </div>
                           </div>
                           <div class="pdf-card-row">
                              <div class="pdf-card-col">
                                 <span class="pdf-card-label">Telefone:</span>
                                 <span class="pdf-card-value">{{ sentenciado.telefoneSentenciado || '-' }}</span>
                              </div>
                              <div class="pdf-card-col">
                                 <span class="pdf-card-label">Documento:</span>
                                 <span class="pdf-card-value">{{ formatarDocumento(sentenciado.tipoDocumento, sentenciado.identificacao) }}</span>
                              </div>
                           </div>
                           <div class="pdf-card-row" v-if="sentenciado.enderecoSentenciado">
                              <div class="pdf-card-col-full">
                                 <span class="pdf-card-label">Endereço:</span>
                                 <span class="pdf-card-value">{{ sentenciado.enderecoSentenciado }}</span>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>

            <div class="pdf-container" v-if="isRelatorioMacro && dadosPdfMacro">
               <div class="pdf-header">
                  <div class="pdf-header-content">
                     <div class="pdf-header-info text-center" style="width: 100%;">
                        <h2 class="pdf-title text-center">{{ dadosPdfMacro.dadosHeader ? dadosPdfMacro.dadosHeader.nome : 'CONSELHO DA COMUNIDADE' }}</h2>
                        <div class="pdf-subtitle text-center">{{ dadosPdfMacro.dadosHeader ? dadosPdfMacro.dadosHeader.linha1 : 'ÓRGÃO DE EXECUÇÃO PENAL' }}</div>
                        <div class="pdf-subtitle text-center mt-3 mb-2 font-weight-bold" style="font-size: 16px; color: #000;">Entidades Onde Há Apenados</div>
                     </div>
                  </div>
               </div>

               <div class="pdf-macro-section mt-4">
                  <table class="table table-bordered table-sm" style="color: #000; border-color: #dee2e6;">
                     <thead style="background-color: #f8f9fa;">
                        <tr>
                           <th style="width: 80%; padding: 8px;">Nome da Entidade</th>
                           <th class="text-center" style="width: 20%; padding: 8px;">Nº de Apenados</th>
                        </tr>
                     </thead>
                     <tbody>
                        <tr v-for="(item, index) in dadosPdfMacro.listaResultado" :key="index">
                           <td style="padding: 6px 8px;">{{ item.nomeEntidade }}</td>
                           <td class="text-center" style="padding: 6px 8px;">{{ item.totalVinculados }}</td>
                        </tr>
                     </tbody>
                     <tfoot>
                        <tr style="background-color: #f8f9fa;">
                           <th class="text-right" style="padding: 8px;">Total Geral de Apenados:</th>
                           <th class="text-center" style="padding: 8px;">{{ dadosPdfMacro.totalGeralApenados }}</th>
                        </tr>
                     </tfoot>
                  </table>
               </div>
            </div>
         </section>
      </div>
   </div>
</template>

<script>
import $ from 'jquery'
import { mapState } from 'vuex'
import vuePDF from 'html2pdf.js'
import servico from '@/components/entidades/Servico.vue'
import entidade from '@/components/entidades/Entidade.vue'
import sentenciado from '@/components/entidades/Sentenciado.vue'

export default {
	name: 'Entidades',
   data: function () {
      return {
         pesquisa: { 'tipo': 'Nome', 'valor': null, 'cnpj': null, 'resultado': [] },
         modal: { 'id': null, 'nome': null, 'cnpj': null, 'cep': null, 'telefone': null, 'endereco': null, 'feedback': false, 'email': null, 'nomeResponsavel': null, 'telefoneResponsavel': null },
         modalInfo: { 'id': null, 'servicos': [], 'sentenciados': [] },
         modalRelatorio: { 'entidadeId': null, 'entidadeNome': '', 'entidadeOpcao': '', 'varaOrigem': 'Todos', 'sexo': 'Todos', 'filtro': 'Todos' },
         filtrosModal: { 'nome': '', 'vara': 'Todos', 'sexo': 'Todos', 'status': 'Todos' },
         dadosPdf: { 'sentenciado': [] },
         dadosPdfMacro: null,
         isRelatorioMacro: false,
         pagina: 0,
         totalPagina: 0,
      }
   },
   computed: {
      ... mapState({
         tokenSessao: state => state.tokenSessao,
         urlRest: state => state.urlRest
      }),
      
      sentenciadosFiltrados() {
         if (!this.modalInfo.sentenciados) return [];
         
         return this.modalInfo.sentenciados.filter(s => {
            const bateNome = !this.filtrosModal.nome || s.nomeCompleto.toLowerCase().includes(this.filtrosModal.nome.toLowerCase());
            const bateVara = this.filtrosModal.vara === 'Todos' || (s.varaOrigem && s.varaOrigem.toLowerCase() === this.filtrosModal.vara.toLowerCase());
            const bateSexo = this.filtrosModal.sexo === 'Todos' || (s.sexo && s.sexo.toLowerCase() === this.filtrosModal.sexo.toLowerCase());
            const bateStatus = this.filtrosModal.status === 'Todos' || (s.status && s.status.toLowerCase() === this.filtrosModal.status.toLowerCase());
            
            return bateNome && bateVara && bateSexo && bateStatus;
         });
      }
   },
   watch: {
      'modal.feedback' : function (value) {
         if (value != true) {
            this.modal.email = null;
         }
      }
   },
   components: {
      entidade, servico, sentenciado
   },
   methods: {
      buscarEntidades(pagina) {
         let ref = this;
         this.pagina = pagina == null ? ++this.pagina : pagina
         
         this.$store.dispatch('alternarTelaCarregamento', true)
         this.$axios({
            method: 'get',
            url: this.urlRest +'entidades/searchEntidades',
            params: {
               tipo: this.pesquisa.tipo,
               valor: this.pesquisa.valor,
               page: this.pagina
            }
         }).then(response => {
            if (this.pagina == 0) {
               this.pesquisa.resultado = []
            }
            this.totalPagina = response.data.length
            response.data.forEach(p => {
               this.pesquisa.resultado.push(p)
            });
         }).catch(function (error) {
            if (error.response != undefined) {
               if (error.response.status == 408) {
                  ref.$store.dispatch('deslogar')
                  ref.$toast.fire({ icon: 'warning', title: 'Sessão expirada!' });
               } else {
                  ref.$toast.fire({ icon: 'error', title: 'Erro: ' + error.response.status });
               }
            } else {
               ref.$toast.fire({ icon: 'error', title: error });
            }
         }).finally(() => {
            this.$store.dispatch('alternarTelaCarregamento', false)
         });
      },
      abrirAddEntidade() {
         this.modal = { 'id': null, 'nome': null, 'cnpj': null, 'cep': null, 'telefone': null, 'endereco': null, 'feedback': false, 'email': null, 'nomeResponsavel': null, 'telefoneResponsavel': null }
         setTimeout(() => {
            $('#modalEntidade').modal('show')
         }, 100);
      },
      abrirEditarEntidade(entidadeObj) {
         this.modal = {
            'id': entidadeObj.id,
            'nome': entidadeObj.nome,
            'cnpj': entidadeObj.cnpj,
            'cep': entidadeObj.cep || null,
            'telefone': entidadeObj.telefone,
            'endereco': entidadeObj.endereco,
            'feedback': entidadeObj.email != null,
            'email': entidadeObj.email,
            'nomeResponsavel': entidadeObj.nomeResponsavel, 
            'telefoneResponsavel': entidadeObj.telefoneResponsavel
         }
         setTimeout(() => {
            $('#modalEntidade').modal('show')
         }, 100);
      },
      buscarCEP() {
         let ref = this;
         this.$store.dispatch('buscarCEP', this.modal.cep).then(function(data) {
            ref.modal.endereco = data;
			})
      },
      salvarEntidade() {
         if (this.modal.nome == null || this.modal.nome.trim().length == 0) {
            this.$toast.fire({ icon: 'error', title: 'Nome inválido!' }); return;
         } else if (this.modal.cnpj == null || this.modal.cnpj.trim().length == 0) {
            this.$toast.fire({ icon: 'error', title: 'CNPJ inválido!' }); return;
         } else if (this.modal.feedback && (this.modal.email == null || this.modal.email.trim().length == 0)) {
            this.$toast.fire({ icon: 'error', title: 'Email inválido!' }); return;
         }

         let ref = this;
			this.$store.dispatch('alternarTelaCarregamento', true)
         this.$axios({
            method: 'post',
            url: this.urlRest +'entidades/saveEntidade',
            headers: { 'Content-Type': 'application/json' },
				data: this.modal
         }).then(function () {
				$('#modalEntidade').modal('hide')
            if (ref.modal.id == null) {
               ref.pesquisa.tipo = 'Nome'
               ref.pesquisa.valor = ref.modal.nome
            }
            ref.buscarEntidades(0)
            ref.$toast.fire({ icon: 'success', title: 'Entidade salva!' })
         }).catch(function (error) {
            if (error.response != undefined) {
               if (error.response.status == 408) {
                  ref.$store.dispatch('deslogar')
                  ref.$toast.fire({ icon: 'warning', title: 'Sessão expirada!' });
               } else if (error.response.status == 409) {
                  ref.$toast.fire({ icon: 'error', title: 'Email já existente!' });
               } else if (error.response.status == 403) {
                  ref.$toast.fire({ icon: 'error', title: 'CNPJ já existente!' });
               } else { ref.$toast.fire({ icon: 'error', title: 'Erro: ' + error.response.status }) }
            } else { ref.$toast.fire({ icon: 'error', title: error }) }
         }).finally(() => {
            this.$store.dispatch('alternarTelaCarregamento', false)
         })
      },
      verEntidade(idEntidade) {
         this.modalInfo.id = idEntidade
         this.filtrosModal = { 'nome': '', 'vara': 'Todos', 'sexo': 'Todos', 'status': 'Todos' };
         this.getEntidadeServico(idEntidade)
         this.getEntidadeSentenciados(idEntidade)
         $('#modalVerEntidade').modal('show')
      },
      getEntidadeServico(idEntidade) {
         let ref = this;
         this.$store.dispatch('alternarTelaCarregamento', true)
         this.$axios({
            method: 'get',
            url: this.urlRest +'entidades/getEntidadeServico',
            params: { id: idEntidade }
         }).then(response => {
				this.modalInfo.servicos = response.data
         }).catch(function (error) {
            if (error.response != undefined) {
               if (error.response.status == 408) {
                  ref.$store.dispatch('deslogar'); ref.$toast.fire({ icon: 'warning', title: 'Sessão expirada!' });
               } else { ref.$toast.fire({ icon: 'error', title: 'Erro: ' + error.response.status }); }
            } else { ref.$toast.fire({ icon: 'error', title: error }); }
         }).finally(() => {
            this.$store.dispatch('alternarTelaCarregamento', false)
         });
      },
      getEntidadeSentenciados(idEntidade) {
         let ref = this;
         this.$store.dispatch('alternarTelaCarregamento', true)
         this.$axios({
            method: 'get',
            url: this.urlRest +'entidades/getEntidadeSentenciados',
            params: { id: idEntidade }
         }).then(response => {
				this.modalInfo.sentenciados = response.data
         }).catch(function (error) {
            if (error.response != undefined) {
               if (error.response.status == 408) {
                  ref.$store.dispatch('deslogar'); ref.$toast.fire({ icon: 'warning', title: 'Sessão expirada!' });
               } else { ref.$toast.fire({ icon: 'error', title: 'Erro: ' + error.response.status }); }
            } else { ref.$toast.fire({ icon: 'error', title: error }); }
         }).finally(() => {
            this.$store.dispatch('alternarTelaCarregamento', false)
         });
      },
      imprimirRelatorio(entidadeObj) {
         this.modalRelatorio = {
            entidadeId: entidadeObj.id,
            entidadeNome: entidadeObj.nome || '',
            entidadeOpcao: entidadeObj.nome || '',
            varaOrigem: 'Todos',
            sexo: 'Todos',
            filtro: 'Todos'
         };
         setTimeout(() => {
            $('#modalRelatorioEntidade').modal('show')
         }, 100);
      },
      gerarRelatorioEntidade() {
         let ref = this
         this.$store.dispatch('alternarTelaCarregamento', true)
         
         if (this.modalRelatorio.entidadeOpcao === 'Todas') {
            this.isRelatorioMacro = true;
            this.$axios({
               method: 'get',
               url: this.urlRest +'entidades/getApenadosPorEntidade',
               params: {
                  sexo: this.modalRelatorio.sexo === 'Todos' ? null : this.modalRelatorio.sexo,
                  varaOrigem: this.modalRelatorio.varaOrigem === 'Todos' ? null : this.modalRelatorio.varaOrigem,
                  filtro: this.modalRelatorio.filtro === 'Todos' ? null : this.modalRelatorio.filtro
               }
            }).then(response => {
               this.dadosPdfMacro = response.data
               if (this.dadosPdfMacro && this.dadosPdfMacro.listaResultado && this.dadosPdfMacro.listaResultado.length > 0) {
                  setTimeout(() => {
                     this.downloadPdf()
                  }, 200);
                  $('#modalRelatorioEntidade').modal('hide')
                  this.$toast.fire({ icon: 'success', title: 'Relatório gerado com sucesso!' });
               } else {
                  ref.$toast.fire({ icon: 'warning', title: 'Nenhum registro encontrado para os filtros selecionados!' });
               }
            }).catch(function (error) {
               if (error.response != undefined) {
                  if (error.response.status == 408) {
                     ref.$store.dispatch('deslogar'); ref.$toast.fire({ icon: 'warning', title: 'Sessão expirada!' });
                  } else { ref.$toast.fire({ icon: 'error', title: 'Erro: ' + error.response.status }); }
               } else { ref.$toast.fire({ icon: 'error', title: error }); }
            }).finally(() => {
               this.$store.dispatch('alternarTelaCarregamento', false)
            });
         } else {
            this.isRelatorioMacro = false;
            this.$axios({
               method: 'get',
               url: this.urlRest +'entidades/relatorioEntidade',
               params: {
                  id: this.modalRelatorio.entidadeId,
                  sexo: this.modalRelatorio.sexo === 'Todos' ? null : this.modalRelatorio.sexo,
                  varaOrigem: this.modalRelatorio.varaOrigem === 'Todos' ? null : this.modalRelatorio.varaOrigem,
                  filtro: this.modalRelatorio.filtro === 'Todos' ? null : this.modalRelatorio.filtro
               }
            }).then(response => {
               this.dadosPdf = response.data
               if (this.dadosPdf.sentenciado && this.dadosPdf.sentenciado.length > 0) {
                  setTimeout(() => {
                     this.downloadPdf()
                  }, 200);
                  $('#modalRelatorioEntidade').modal('hide')
                  this.$toast.fire({ icon: 'success', title: 'Relatório gerado com sucesso!' });
               } else {
                  ref.$toast.fire({ icon: 'warning', title: 'Nenhum registro encontrado para os filtros selecionados!' });
               }
            }).catch(function (error) {
               if (error.response != undefined) {
                  if (error.response.status == 408) {
                     ref.$store.dispatch('deslogar'); ref.$toast.fire({ icon: 'warning', title: 'Sessão expirada!' });
                  } else { ref.$toast.fire({ icon: 'error', title: 'Erro: ' + error.response.status }); }
               } else { ref.$toast.fire({ icon: 'error', title: error }); }
            }).finally(() => {
               this.$store.dispatch('alternarTelaCarregamento', false)
            });
         }
      },
      formatarData(data) {
         if (!data) return '-'
         const dia = data.dayOfMonth.toString().padStart(2, '0')
         const mes = data.monthValue.toString().padStart(2, '0')
         const ano = data.year
         return `${dia}/${mes}/${ano}`
      },
      formatarDocumento(tipoDocumento, identificacao) {
         if (!tipoDocumento || !identificacao) return '-'
         return `${tipoDocumento} ${identificacao}`
      },
      downloadPdf() {
         let filename = 'Relatório Entidade - ' + (this.dadosPdf.nome || 'Entidade') + '.pdf';
         if (this.isRelatorioMacro) {
            filename = 'Relatório Estatístico - Entidades.pdf';
         }

         vuePDF(this.$refs.html2Pdf, {
            margin: [15, 12, 15, 12],
            filename: filename,
            image: { type: 'jpeg', quality: 1 },
            pagebreak: { mode: ['avoid-all', 'css', 'legacy'], avoid: '.pdf-sentenciado-card, tr' },
            html2canvas: { letterRendering: true, useCORS: true, dpi: 300, scale: 2 },
            jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait', hotfixes: ['px_scaling'] }
         })
      },
   },
   mounted() {
      $('#search-nav .dropdown-menu').on('click', function(e) {
         if (e.target.nodeName != 'BUTTON') { e.stopPropagation(); }
      });
      this.buscarEntidades(0)
   }
}
</script>

<style scoped>
.pdf-container {
   width: 100%;
   max-width: 210mm;
   margin: 0 auto;
   padding: 0;
   font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
   color: #000;
   background: #fff;
}
.pdf-header {
   margin-bottom: 12px;
   padding-bottom: 10px;
   border-bottom: 2px solid #333;
}
.pdf-header-content {
   display: flex;
   justify-content: flex-start;
   align-items: flex-start;
}
.pdf-header-info {
   flex: 1;
}
.pdf-title {
   font-size: 24px;
   font-weight: 700;
   margin: 0 0 5px 0;
   color: #000;
}
.pdf-subtitle {
   font-size: 14px;
   color: #666;
   font-weight: 500;
}
.pdf-entity-info {
   margin-bottom: 15px;
   padding: 12px;
   background: #f8f9fa;
   border-radius: 4px;
   border-left: 4px solid #333;
}
.pdf-info-row {
   display: flex;
   flex-wrap: wrap;
   margin-bottom: 10px;
   gap: 20px;
}
.pdf-info-row:last-child { margin-bottom: 0; }
.pdf-info-item {
   flex: 1;
   min-width: 200px;
}
.pdf-label {
   font-weight: 600;
   color: #333;
   margin-right: 8px;
   font-size: 13px;
}
.pdf-value {
   color: #000;
   font-size: 13px;
}
.pdf-sentenciados-section { margin-top: 15px; }
.pdf-section-title {
   font-size: 18px;
   font-weight: 700;
   margin: 0 0 10px 0;
   color: #000;
   padding-bottom: 6px;
   border-bottom: 1px solid #ddd;
}
.pdf-relatorio-stats {
   display: flex;
   flex-wrap: wrap;
   gap: 2mm;
}
.pdf-stat-badge {
   font-size: 7pt;
   font-weight: 600;
   padding: 1.5mm 3mm;
   background: #f5f5f5;
   border: 1px solid #d0d0d0;
   border-radius: 2px;
   color: #000000;
   white-space: nowrap;
}
.pdf-sentenciados-list {
   display: flex;
   flex-direction: column;
   gap: 8px;
}
.pdf-sentenciado-card {
   page-break-inside: avoid;
   break-inside: avoid;
   margin-bottom: 8px;
   padding: 10px;
   border: 1px solid #ddd;
   border-radius: 4px;
   background: #fff;
   box-shadow: 0 1px 2px rgba(0, 0, 0, 0.08);
}
.pdf-card-header {
   display: flex;
   align-items: center;
   margin-bottom: 8px;
   padding-bottom: 6px;
   border-bottom: 1px solid #eee;
}
.pdf-card-number {
   font-weight: 700;
   font-size: 14px;
   color: #000;
   margin-right: 8px;
   flex-shrink: 0;
}
.pdf-card-name {
   font-size: 14px;
   font-weight: 600;
   color: #000;
   flex: 1;
}
.pdf-card-body {
   display: flex;
   flex-direction: column;
   gap: 6px;
}
.pdf-card-row {
   display: flex;
   flex-wrap: wrap;
   gap: 15px;
}
.pdf-card-col {
   flex: 1;
   min-width: 200px;
}
.pdf-card-col-full { flex: 1 1 100%; }
.pdf-card-label {
   font-weight: 600;
   color: #555;
   font-size: 12px;
   margin-right: 6px;
}
.pdf-card-value {
   color: #000;
   font-size: 12px;
}
@media print {
   .pdf-container { max-width: 100%; }
   .pdf-sentenciado-card { page-break-inside: avoid; break-inside: avoid; }
}
</style>